// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1BtOt","visuallyhidden":"_2SOgk","hide-text":"_3Z0Xv","center":"GJuov","noprint":"_3JHLf","front":"_1jqVv","subheader":"SFAgA","tagTitle":"_1jy8G","articleCards":"_3CgFR","imageWrapper":"_3j9Da","plussIndicator":"_3ahOi","articleCard":"_2Ce8c","fullWidthMobile":"M4ISW","showMore":"_2CSdW","fullWidthDesktop":"_2a4ux","root":"_3gN6E","filterButtons":"_1GyGH","filterIndicator":"_2bo2g","active":"_1I0JH"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/theme/pluss-front/default.scss
 ** module id = 981
 ** module chunks = 2
 **/